<template>
    <div class="ah-page estimate-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>年度預估營業淨收</h1>
                        <el-select v-model="year" class="title-dropdown" @change="onChangeYear">
                            <el-option v-for="item in yearList" :key="`year-${item.value}`" :value="item.value" :label="item.label"></el-option>
                        </el-select>
                    </div>
                    <div class="actions">
                        <el-button type="dark-transparent" icon="el-icon-printer" @click="onPrint">列印 </el-button>
                        <el-button @click="onSave" style="margin-right: 5px; line-height: ">
                            存檔
                        </el-button>
                        <el-dropdown>
                            <el-button> 載入存檔<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :disabled="true">
                                    <span v-if="savedDatas.length > 0">僅儲存於當前電腦</span>
                                    <span v-if="savedDatas.length == 0">（尚未有存檔紀錄）</span>
                                </el-dropdown-item>
                                <el-dropdown-item v-for="(item, index) in savedDatas" :key="`saved-${index}`" @click.native="onLoadData(item)">
                                    {{ item.name }}
                                    <el-button size="mini" icon="el-icon-delete" style="margin-left: 5px" @click="onDeleteSave($event, index)"> </el-button>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-body">
                    <div class="mode-switcher" style="text-align: center;">
                        <el-radio-group v-model="mode" @change="reloadSaveDatas">
                            <el-radio-button :label="1">總額編列</el-radio-button>
                            <el-radio-button :label="2">明細編列</el-radio-button>
                        </el-radio-group>
                    </div>
                    <SimpleLayout ref="SimpleLayout" v-if="mode === 1 && estimatedEarnings" :is-loading="isLoading" :year="year" :data="estimatedEarnings" :save-key="saveKey" />
                    <AdvanceLayout
                        ref="AdvanceLayout"
                        v-if="mode === 2 && estimatedEarnings && actuallyInvoiceAmountList && actuallyPaymentAmountList"
                        :is-loading="isLoading"
                        :year="year"
                        :data="estimatedEarnings"
                        :actuallyInvoiceAmountList="actuallyInvoiceAmountList"
                        :actuallyPaymentAmountList="actuallyPaymentAmountList"
                        :save-key="saveKey"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import SimpleLayout from '@/components/dashboard/Finance/Analysis/EstimatePage/SimpleLayout.vue';
import AdvanceLayout from '@/components/dashboard/Finance/Analysis/EstimatePage/AdvanceLayout.vue';

export default {
    components: { SimpleLayout, AdvanceLayout },
    data() {
        return {
            isLoading: false,
            savedDatas: [],
            tableData: [],
            hideChildItems: false,

            year: moment().year(),
            yearList: [],
            mode: 1,

            estimatedEarnings: { statisticsInfo: {} },
            actuallyInvoiceAmountList: undefined,
            actuallyPaymentAmountList: undefined,
        };
    },
    computed: {
        saveKey() {
            return this.mode === 1 ? 'estimate-simple-saves' : 'estimate-advance-saves';
        },
        refLayout() {
            const REF = this.mode === 1 ? 'SimpleLayout' : 'AdvanceLayout';
            return this.$refs[REF];
        },
    },
    mounted() {
        this.initYearSelect();
        this.fetchData();
        this.reloadSaveDatas();
    },
    methods: {
        initYearSelect() {
            const START = 2020;
            const END = moment().year();

            for (let i = END; i >= START; i -= 1) {
                this.yearList.push({ label: i, value: i });
            }
        },
        reloadSaveDatas() {
            this.savedDatas = JSON.parse(localStorage.getItem(this.saveKey)) ?? [];
        },
        async fetchData() {
            this.isLoading = true;
            try {
                const resp = await this.$api({
                    url: '/EstimatedEarnings/GetYearlyEstimatedEarnings',
                    params: { year: this.year },
                    method: 'GET',
                });
                console.log(resp);

                this.estimatedEarnings = {
                    ...resp.data.estimatedEarnings,
                    statisticsInfo: resp.data.statisticsInfo,
                };

                this.actuallyInvoiceAmountList = resp.data.actuallyInvoiceAmountList;
                this.actuallyPaymentAmountList = resp.data.actuallyPaymentAmountList;
            } finally {
                this.isLoading = false;
            }
        },

        onChangeYear() {
            this.fetchData();
        },
        onPrint() {
            window.print();
        },
        onSave() {
            const DATA = this.refLayout.getTableData();
            const DATE = moment().format('YYYY-MM-DD HH:mm');

            this.savedDatas.push({
                name: `${this.year}年度預估營業淨收 ${DATE}`,
                data: DATA,
            });
            localStorage.setItem(this.saveKey, JSON.stringify(this.savedDatas));

            this.$message({
                message: '已儲存',
                showClose: true,
                type: 'success',
            });
        },
        onLoadData(data) {
            this.refLayout.loadLocalData(data);
        },
        onDeleteSave(event, index) {
            this.savedDatas.splice(index, 1);
            localStorage.setItem(this.saveKey, JSON.stringify(this.savedDatas));

            this.reloadSaveDatas();
            event.stopPropagation();
            event.preventDefault();
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.estimate-page {
    @media print {
        .mode-switcher {
            display: none;
        }
    }
}
</style>
